import * as PIXI from 'pixi.js'
import { GlowFilter } from 'pixi-filters'
import gsap from 'gsap'

import AssetsManager from '../../../pixi/AssetsManager'
import CardView from './CardView'

/**
 * FinishAreaクラス
 */
class FinishArea extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //コンテナ
  private _container: PIXI.Container

  //グローフィルター
  private _glowFilter: GlowFilter

  // ---------------------------------------------------------------------------------------------------------
  // --	FinishArea
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //影
    const shadow: PIXI.Sprite = AssetsManager.instance.createSpriteByName('card_shadow.png')
    shadow.anchor.set(0.5)
    shadow.scale.set(3.0)
    shadow.alpha = 0.2
    this.addChild(shadow)

    //数字
    const numberLarge: PIXI.AnimatedSprite = AssetsManager.instance.createMovieClipFromAnimation(
      'ss',
      'num_b'
    )
    numberLarge.anchor.set(0.5)
    numberLarge.scale.set(4)
    numberLarge.gotoAndStop(0)
    numberLarge.alpha = 0.2
    this.addChild(numberLarge)

    //コンテナ配置
    this._container = new PIXI.Container()
    this.addChild(this._container)

    //グローフィルター
    this._glowFilter = new GlowFilter({
      distance: 15,
      outerStrength: 2,
      innerStrength: 0,
      color: 0xffff00,
      quality: 0.5,
    })
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	METHODS
  // ---------------------------------------------------------------------------------------------------------

  /**
   * カードを追加する
   */
  public addCards(cards: Array<CardView>): void {
    //カードをコンテナに追加
    for (let i = 0; i < cards.length; i++) {
      //カード参照
      const card: CardView = cards[i]

      //ローカル座標に変換して配置
      const globalCardPos: PIXI.Point = card.parent.toGlobal(card.position)
      const localPos: PIXI.Point = this.toLocal(globalCardPos)
      card.x = localPos.x
      card.y = localPos.y
      this._container.addChild(card)

      //アニメーション
      gsap.to(card, {
        x: 0,
        y: 0,
        duration: 0.1,
        ease: 'power2.out',
      })
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	UTILs
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ドラッグ中のカードとのヒットテスト
   */
  public hitTest(pos: PIXI.Point): boolean {
    const bounds: PIXI.Rectangle = this.getBounds()
    if (bounds.contains(pos.x, pos.y)) {
      this.filters = [this._glowFilter]
      return true
    } else {
      this.filters = []
      return false
    }
  }

  /**
   * フォーカスを外す
   */
  public unfocus(): void {
    this.filters = []
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default FinishArea
